var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYahoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10736_100830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.85 5.55C23.7 5.4 23.475 5.25 23.25 5.25H15C14.55 5.25 14.25 5.55 14.25 6V8.25C14.25 8.7 14.55 9 15 9H15.075L13.425 11.25L10.2 6H12C12.45 6 12.75 5.7 12.75 5.25V3C12.75 2.55 12.45 2.25 12 2.25H1.5C1.05 2.25 0.75 2.55 0.75 3V5.25C0.75 5.7 1.05 6 1.5 6H3.225L9 14.475V19.5H6.75C6.3 19.5 6 19.8 6 20.25V22.5C6 22.95 6.3 23.25 6.75 23.25H17.25C17.7 23.25 18 22.95 18 22.5V20.25C18 19.8 17.7 19.5 17.25 19.5H15V15.825L19.875 9H22.5C22.8 9 23.1 8.775 23.175 8.475L23.925 6.225C24.075 6 24 5.775 23.85 5.55Z",
    fill: "#6001D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10736_100830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahoo);
export default __webpack_public_path__ + "static/media/yahoo.39a5522678b897ad88c6ba5fe03eb997.svg";
export { ForwardRef as ReactComponent };